import * as React from 'react';
import Svg, {G, Path, Defs, ClipPath} from 'react-native-svg';

export default class CompMilk extends React.Component {
  render() {
    return (
      <Svg width={36} height={36} viewBox="0 0 36 36" fill="none">
        <G
          clipPath="url(#clip0_3212_12368)"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M27.818 0H6.545v5.727h21.273V0zm-8.182 14.727l6.546-6.545H6.545L0 14.727h19.636zM36 36V17.182L28.636 9l-7.363 8.182V36H36zm-17.182 0V17.182H0V36h18.818z"
            fill="#009CDE"
          />
          <Path
            d="M3.905 23.733v-.817h1.633v8.573H3.905v-7.757zm11.062 0v-.817h-1.633v8.573h1.633v-7.757zm-3.143-.817v4.9H10.19v-4.9h1.633zm-1.633 7.758v.816h1.633V29.45H10.19v1.224zm-1.51-7.758v4.9H7.048v-4.9H8.68zm-1.633 7.758v.816H8.68V29.45H7.048v1.224z"
            fill="#111"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_3212_12368">
            <Path fill="#fff" d="M0 0H36V36H0z" />
          </ClipPath>
        </Defs>
      </Svg>
    );
  }
}
